module.exports = __webpack_public_path__ + "img/icon_aside_word4_hover.e9f30c87.svg";